import { useEffect } from 'react';

const DEVTOOLS_THRESHOLD = 160;

function detectDevToolsByViewport() {
  if (typeof window === 'undefined') return false;
  const widthGap = window.outerWidth - window.innerWidth;
  const heightGap = window.outerHeight - window.innerHeight;
  return widthGap > DEVTOOLS_THRESHOLD || heightGap > DEVTOOLS_THRESHOLD;
}

function isDevToolsShortcut(event) {
  const key = (event.key || '').toLowerCase();
  const ctrlOrMeta = event.ctrlKey || event.metaKey;
  return (
    key === 'f12' ||
    (ctrlOrMeta && event.shiftKey && (key === 'i' || key === 'j' || key === 'c'))
  );
}

export function useDevToolsGuard({ enabled, onDetected }) {
  useEffect(() => {
    if (!enabled || typeof onDetected !== 'function') {
      return undefined;
    }

    let triggered = false;
    const fireDetected = () => {
      if (triggered) return;
      triggered = true;
      onDetected();
    };

    const onKeyDown = (event) => {
      if (isDevToolsShortcut(event)) {
        fireDetected();
      }
    };

    const intervalId = window.setInterval(() => {
      if (detectDevToolsByViewport()) {
        fireDetected();
      }
    }, 800);

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [enabled, onDetected]);
}

